import { debug } from "lib/log";
import { Sentry } from "lib/sentry";
import { useEffect } from "react";

type CallbackType = (err: Error) => void;

// https://help.branch.io/developers-hub/docs/branch-event-ontology
type BranchEvent =
  | "COMPLETE_REGISTRATION" // converted
  | "PURCHASE"; // completed

interface BranchAPI {
  init(
    id: string,
    options?: Record<string, unknown>,
    callback?: CallbackType
  ): void;
  track(
    event: BranchEvent,
    metadata?: Record<string, unknown>,
    callback?: CallbackType
  ): void;
  logEvent(
    event: BranchEvent,
    event_data_and_custom_data?: Record<string, unknown>,
    content_items?: unknown[],
    customer_event_alias?: string,
    callback?: CallbackType
  ): void;
  setIdentity(identity: string, callback?: CallbackType): void;
  logout(callback?: CallbackType): void;
}

declare global {
  interface Window {
    branch: BranchAPI;
  }
}

if (process.browser) {
  // branch-sdk package is not SSR-friendly, so only load it in the browser.
  require("branch-sdk");
}

export const useBranchAnalytics = () => {
  useEffect(() => {
    window.branch?.init(process.env.NEXT_PUBLIC_BRANCH_IO_KEY, {}, (err) => {
      if (err) {
        debug.error(err);
        Sentry.captureException(err);
        return;
      }

      debug("branch SDK initialised");
    });
  }, []);
};
